import Image from '@/components/Image';
import Styled from '@/components/StatisticsBlock/StatisticsBlock.styled';
import { FC, ReactNode } from 'react';
import CountUp from 'react-countup';

export type StatisticsBlockStatisticType = {
  id: string | number;
  prefix?: string;
  statistic: number | string;
  suffix?: string;
  countUp?: boolean;
  content: ReactNode;
  logo: {
    url: string;
    width: number;
    height: number;
    isLarger: boolean;
  };
};

interface StatisticsBlockProps {
  heading?: string;
  statistics: StatisticsBlockStatisticType[];
}

const StatisticsBlock: FC<StatisticsBlockProps> = (props) => {
  return (
    <Styled.Wrapper>
      {props.heading && <Styled.Heading id="statistics-block-heading">{props.heading}</Styled.Heading>}

      <Styled.Grid>
        {props.statistics.map((stat, index) => (
          <Styled.StatisticWrapper key={stat.id}>
            <Styled.LogoContainer $isTaller={stat.logo.isLarger ?? false}>
              <Image src={stat.logo.url} width={stat.logo.width} height={stat.logo.height} alt="" />
            </Styled.LogoContainer>

            <Styled.Statistic>
              {stat.countUp ? (
                <CountUp
                  start={0}
                  prefix={stat.prefix}
                  end={typeof stat.statistic === 'string' ? parseInt(stat.statistic, 10) : stat.statistic}
                  suffix={stat.suffix}
                  duration={1.5}
                  delay={(index + 1) * 0.35}
                  scrollSpyDelay={(index + 1) * 0.35}
                  enableScrollSpy
                  useEasing
                />
              ) : (
                <span>{[stat.prefix ?? '', stat.statistic ?? '', stat.suffix ?? ''].join('')}</span>
              )}
            </Styled.Statistic>

            {stat.content}
          </Styled.StatisticWrapper>
        ))}
      </Styled.Grid>
    </Styled.Wrapper>
  );
};

StatisticsBlock.defaultProps = {
  statistics: [],
};

export default StatisticsBlock;
